module.exports = __webpack_public_path__ + "img/weather49.83fa1522.png";